import styled from 'styled-components'
import { Style } from '../../styles'

const MapContainer = styled.div`
  background: rgba(9,30,66,.04);
  overflow: hidden;
  border-radius: ${Style.variables.baseBorderRadius};
`

export default MapContainer